
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "ActivitySchedule": [
      "ActivityScheduleEveryNDays",
      "ActivityScheduleEveryVisit",
      "ActivityScheduleFollowVisitSeries",
      "ActivityScheduleOneOff"
    ],
    "CareSubject": [
      "CareHome",
      "CareRecipient"
    ],
    "Event": [
      "Absence",
      "Visit"
    ],
    "FeedItem": [
      "Carelog",
      "Visit"
    ],
    "FeedItemChanges": [
      "FeedItemDiffs",
      "FeedItemValues"
    ],
    "FeedItemContent": [
      "Absence",
      "Carelog",
      "Visit"
    ],
    "Field": [
      "CheckboxField",
      "DateField",
      "RadioField",
      "TextArea",
      "TextField"
    ],
    "HomeStay": [
      "HomeStayInstance",
      "HomeStayLog"
    ],
    "IntegrationSettings": [
      "IntegrationSettingsApiKey",
      "IntegrationSettingsUserPass"
    ],
    "OrganizationUnit": [
      "Division",
      "Office",
      "Region",
      "Tenant"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ActivitySchedule": [
      "ActivityScheduleEveryNDays",
      "ActivityScheduleEveryVisit",
      "ActivityScheduleFollowVisitSeries",
      "ActivityScheduleOneOff"
    ],
    "CareSubject": [
      "CareHome",
      "CareRecipient"
    ],
    "Event": [
      "Absence",
      "Visit"
    ],
    "FeedItem": [
      "Carelog",
      "Visit"
    ],
    "FeedItemChanges": [
      "FeedItemDiffs",
      "FeedItemValues"
    ],
    "FeedItemContent": [
      "Absence",
      "Carelog",
      "Visit"
    ],
    "Field": [
      "CheckboxField",
      "DateField",
      "RadioField",
      "TextArea",
      "TextField"
    ],
    "HomeStay": [
      "HomeStayInstance",
      "HomeStayLog"
    ],
    "IntegrationSettings": [
      "IntegrationSettingsApiKey",
      "IntegrationSettingsUserPass"
    ],
    "OrganizationUnit": [
      "Division",
      "Office",
      "Region",
      "Tenant"
    ]
  }
};
      export default result;
    